module.exports = __webpack_public_path__ + "static/media/foto_2.e0e21af3.png";